<template>
<div class="view-content">
	  <div class="view-content-info">
		<div class="user-login">
		  	<div class="flex-between flex-center">
				<div class="user-login-title"><a href="/">首页</a>/个人中心/<span>信用账户</span></div>
			</div>
			
			<div class="order-bg">
				<div class="order-num flex-round flex-center">
					<div class="order-num-item">
						<div>{{user.accountPeriod}}天</div>
						<div>到期时长</div>
					</div>
					<div class="order-num-item">
						<div>{{user.totalCreditLimit}}</div>
						<div>信用额度</div>
					</div>
					<div class="order-num-item">
						<div>{{user.useCreditLimit}}</div>
						<div>已用额度</div>
					</div>
					<div class="order-num-item">
						<div>{{user.remainingCreditLimit}}</div>
						<div>剩余额度</div>
					</div>
					<div class="order-num-item">
						<div>{{orderNum}}</div>
						<div>即将到期订单</div>
					</div>
				</div>
				<div class="order-status flex-start flex-center">
					<div :class="settlementStatus === ''?'active':''" @click="changeStatus('')">全部订单</div>
					<div :class="settlementStatus === 1?'active':''" @click="changeStatus(1)">待结算</div>
					<div :class="settlementStatus === 0?'active':''" @click="changeStatus(0)">已结算</div>
				</div>
				<div class="order-list" v-if="total > 0">
					<div class="order-item" v-for="(item, index) in list" :key="item.id">
						<div class="order-top">下单时间:{{item.createTime}}<span>订单编号:{{item.orderNo}}</span></div>
						
						<div class="order-info flex-between flex-center">
							
							<div style="width: 100%;">
								<img class="order-info-image" v-for="(value,key) in item.goodsList" v-if="key < 4" :src="value.goodsSpecImage"></img>
							</div>
							<!-- <img class="order-info-image" :src="item.goodsList[0].goodsSpecImage"></img>
							<div class="order-info-name flex-start flex-center" v-if="item.goodsList.length > 1"><span class="one">{{item.goodsList[0].goodsName}}</span>等多个</div>
							<div class="order-info-name" v-else><span class="one">{{item.goodsList[0].goodsName}}</span></div> -->
							<div class="order-info-status" v-if="item.orderStatus == -2">已关闭</div>
							<div class="order-info-status" v-if="item.orderStatus == -1">已取消</div>
							<div class="order-info-status" v-if="item.orderStatus == 0">待支付</div>
							<div class="order-info-status" v-if="item.orderStatus == 1">待接单</div>
							<div class="order-info-status" v-if="item.orderStatus == 2">待发货</div>
							<div class="order-info-status" v-if="item.orderStatus == 3">待签收</div>
							<div class="order-info-status" v-if="item.orderStatus == 4">已完成</div>
							<div class="order-info-price">
								<div>￥{{item.meetPrice}}</div>
								<div>（含运费：￥{{item.freightPrice}}元）</div>
								<div v-if="item.payType == 1">信用付</div>
								<div v-if="item.payType == 2">线下付款</div>
							</div>
							
							<div class="order-info-button">
								<div class="order-info-button-button" @click="toOrderInfo(item.id)">查看详情</div>
							</div>
							
						</div>
						
					</div>
				</div>
				<div class="page" v-if="total > 0">
				    <el-pagination @current-change="getPageList" :current-page="page" :page-size="limit" layout="total, prev, pager, next" :total="total"></el-pagination>
				</div>
				<noData v-if="list.length == 0 && isLoad == true" msg="暂无订单"></noData>
			</div>
		</div>
	  </div>
	</div>
</template>

<script>
import noData from '@/components/noData.vue'
import {getOrderList,getExpireNum} from "@/api/user"
export default {
	name: 'index',
	components:{
		noData
	},
	data(){
		return {
			list:[],
			page:1,
			limit:5,
			total:0,
			isLoad:false,
			settlementStatus:'',
			orderNum:0
		}
	},
	computed: {
		user() {
			return this.$store.state.user;
		}
	},
	mounted() {
		this.isLoad = false;
		this.$store.dispatch('fetchUser');
		this.getList();
		getExpireNum().then(res=>{
			this.orderNum = res.data;
		})
	},
	methods:{
		getList(){
			getOrderList({condition:{settlementStatus:this.settlementStatus,payType:1},page:this.page,size:this.limit}).then(res=>{
				if(res.code == 1000){
					this.list = res.data.list;
					this.total = res.data.total;
					this.isLoad = true;
				}else{
					return this.$message.error(res.message);
				}
			})
		},
		getPageList(e){
			this.isLoad = false;
			this.page = e;
			this.getList();
		},
		getTop(){
			this.isLoad = false;
			this.page = 1;
			this.getList();
		},
		changeStatus(status){
			this.settlementStatus = status;
			this.getTop();
		},
		toOrderInfo(id){
			this.$router.push("/orderinfo?id="+(id*23+20));
		},
	}
}
</script>

<style lang="scss" scoped>
	.order-num{
		width: 100%;
		border-radius: 8px;
		background: #F8F8F8;
		padding: 30px 0px 24px;
		.order-num-item{
			text-align: center;
			div{
				&:first-of-type{
					font-size: 32px;
					font-weight: 500;
					line-height: 40px;
					color: #E91A12;
				}
				&:last-of-type{
					font-size: 20px;
					color: #070B13;
					margin-top: 8px;
				}
			}
		}
	}
	.no-data{
		width: 100%;
		padding: calc(50vh - 400px) 0px;
		background: #FFFFFF;
		text-align: center;
		img{
			width: 120px;
			height: 120px;
		}
		div{
			font-size: 16px;
			font-weight: 500;
			color: #9E9E9E;
			margin-top: 12px;
		}
	}
	.order-item{
		width: 100%;
		border: 1px solid rgba(7, 11, 19, 0.1);
		box-sizing: border-box;
		margin-top: 20px;
		.order-info{
			padding: 10px 0px 10px 20px;
			box-sizing: border-box;
			width: 100%;
			.order-info-image{
				width: 80px;
				height: 80px;
				border: 1px solid rgba(0, 0, 0, 0.1);
				flex: 0 0 82px;
				margin-right: 20px;
			}
			.order-info-name{
				font-size: 16px;
				color: #070B13;
				width: 100%;
				line-height: 40px;
				span{
					max-width: 300px;
					display: inline-block;
				}
			}
			.order-info-status{
				font-size: 16px;
				color: #070B13;
				flex: 0 0 100px;
				text-align: center;
			}
			.order-info-price{
				font-size: 14px;
				line-height: 22px;
				color: #070B13;
				text-align: center; 
				flex: 0 0 200px;
			}
			.order-info-button{
				border-left: 1px solid rgba(7, 11, 19, 0.1);
				width: 148px;
				text-align: center;
				flex: 0 0 148px;
				.order-info-button-button{
					width: 88px;
					height: 24px;
					border: 1px solid rgba(233, 26, 18, 0.3);
					font-size: 14px;
					line-height: 24px;
					color: #E91A12;
					text-align: center;
					margin: 0 auto 8px;
					cursor: pointer;
				}
				.order-info-button-see{
					width: 88px;
					height: 24px;
					border: 1px solid rgba(7, 11, 19, 0.3);
					font-size: 14px;
					line-height: 24px;
					color: #070B13;
					text-align: center;
					margin: 0 auto 8px;
					cursor: pointer;
					display: block;
				}
			}
		}
		.order-top{
			width: 100%;
			height: 46px;
			background: rgba(233, 26, 18, 0.04);
			font-size: 16px;
			color: #070B13;
			line-height: 46px;
			padding-left: 20px;
			box-sizing: border-box;
			span{
				margin-left: 40px;
			}
		}
	}
	.order-list{
		min-height: 680px;
		background-color: #fff;
	}
	
	.order-status{
		div{
			padding: 20px 0px 6px;
			font-size: 16px;
			line-height: 20px;
			color: #070B13;
			border-bottom: 3px solid #fff;
			margin-right: 60px;
			cursor: pointer;
		}
		.active{
			color: #E91A12;
			border-bottom: 3px solid #E91A12;
		}
	}
	.order-bg{
		background: #fff;
		padding: 40px;
	}
	
</style>
